import { useWebContent } from '../lib/webPrices'
/**
 * Pás výhod (verze 2) — podle návrhu: ikona v kolečku, titulek, dvouřádkový
 * popis, čtyři položky vedle sebe na šedém pruhu s dělicími linkami.
 */
const ITEMS = [
  {
    title: 'U jezera',
    desc: 'Krásné a klidné prostředí přímo u vody',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10c2 0 2-1.5 4-1.5S9 10 11 10s2-1.5 4-1.5 2 1.5 4 1.5M3 15c2 0 2-1.5 4-1.5S9 15 11 15s2-1.5 4-1.5 2 1.5 4 1.5M3 20c2 0 2-1.5 4-1.5S9 20 11 20s2-1.5 4-1.5 2 1.5 4 1.5" />
      </svg>
    ),
  },
  {
    title: 'Sport & relax',
    desc: 'Rybolov, tenis, plážový volejbal a odpočinek v přírodě',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="15" cy="5" r="2" /><path d="M9 21l2-6 3 2 2-5-4-3-3 5M5 12l3-2" />
      </svg>
    ),
  },
  {
    title: 'Restaurace',
    desc: 'Výborné jídlo, výčep a domácí udírna',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 3v7a3 3 0 0 0 6 0V3M10 3v18M17 3c-1.5 2-2 4-2 7h2v11" />
      </svg>
    ),
  },
  {
    title: 'Rodinné pobyty',
    desc: 'Skvělé zázemí pro rodiny s dětmi',
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8" cy="7" r="2.5" /><circle cx="16" cy="8" r="2" /><path d="M3 20c0-4 2.2-6 5-6s5 2 5 6M12 20c0-3 1.8-5 4-5s4 2 4 5" />
      </svg>
    ),
  },
]

export function UspV2() {
  const content = useWebContent()
  const txt = content.usp_items as string | undefined
  const items = txt
    ? txt.split('\n').map((l, i) => { const [t, ...r] = l.split('::'); return { ...ITEMS[Math.min(i, ITEMS.length - 1)], title: (t || '').trim() || ITEMS[i]?.title, desc: r.join('::').trim() || ITEMS[i]?.desc } }).filter((x) => x.title)
    : ITEMS
  return (
    <section className="bg-paper border-y border-ink-900/[0.06]">
      <div className="container-x grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:divide-x divide-ink-900/[0.08]">
        {items.map((it) => (
          <div key={it.title} className="flex items-center gap-4 py-6 lg:py-7 lg:px-6 first:lg:pl-0 last:lg:pr-0">
            <div className="w-14 h-14 rounded-full bg-white border border-ink-900/[0.08] grid place-items-center text-ink-900 shrink-0">
              {it.icon}
            </div>
            <div>
              <div className="font-bold text-[15px] text-ink-900">{it.title}</div>
              <div className="text-[13px] text-ink-700 leading-snug mt-0.5">{it.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
